import React from "react";

const IndiamartButton = () => {
  return (
    <a
      href="https://www.indiamart.com/jyoti-bagmanufacturer/?srsltid=AfmBOoq5QPm5K8UGqfFb07hmQyczjOtRYJG2Zy9zY0DW14uDnX_ZFawX"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 right-4 bg-white w-14 h-14 rounded-full shadow-lg flex items-center justify-center hover:scale-110 transition-transform z-50"
    >
      <img
        src="/images/INDIAMART logo.png"
        alt="IndiaMART"
        className="w-8 h-8 object-contain"
      />
    </a>
  );
};

export default IndiamartButton;